// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__34fUS","left":"StickyBox_left__1WvZV","right":"StickyBox_right__1COO2"};